export default __webpack_public_path__ + "static/media/execute_examQuestions.ed817211.png";